import { useQueries } from '@maui/react-query'
import { useVTApiClient } from './client'

export const useGetPrivateFilesQueries = ({ analyses }, options = {}) => {
  const api = useVTApiClient('privateAnalyses')

  return useQueries({
    queries: analyses.map(({ id, status }) => {
      return {
        queryKey: ['privateAnalyses', { relationship: 'item', id }],
        queryFn: () => api.analysisItem({ id }),
        refetchInterval: (data) => {
          if (!data?.data) return undefined

          // NOTE: the main purpose of this refetchInterval is to handle the case where
          // a file is uploaded, which causes the analyses list query to be triggered again.
          // The uploaded file seems not to have all the properties at this particular point,
          // so we refetch until all expected properties are present OR the analysis status is 'completed'
          // These fields are independent of the analysis status.

          const { data: fileData } = data

          const {
            attributes: {
              names,
              meaningful_name: meaningfulName,
              size,
              sha1,
              sha256,
              md5,
              threat_verdict: threatVerdict,
              last_analysis_date: lastAnalysisDate,
              exiftool: {
                MIMEType
              } = {}
            } = {}
          } = fileData

          if (
            status === 'completed' &&
            doAllPropertiesExist([
              meaningfulName || names,
              size,
              sha1,
              sha256,
              md5,
              lastAnalysisDate,
              MIMEType,
              threatVerdict
            ])
          ) {
            return false
          }

          return 5000
        },
        refetchOnWindowFocus: false,
        enabled: options.enabled !== false && id && analyses.length > 0,
        select: (data) => {
          const clonedData = structuredClone(data)
          return {
            ...clonedData,
            analysisId: id,
          }
        },
        ...options,
      }
    }),
  })
}

const doAllPropertiesExist = (properties) => {
  if (!Array.isArray(properties) || !properties.length > 0) return false
  return properties.every((property) => property !== undefined)
}
